window.addEventListener('DOMContentLoaded', function () {
    $('#collapsible-items input[type="text"], #collapsible-items input[type="number"], #collapsible-items input[type="date"]')
        .not(':disabled, [readonly]')
        .filter(':visible')
        .first()
        .focus();
});
